import { Link } from 'react-router-dom';
import Layout from '../../components/layout/Layout';
import Breadcrumb from '../../components/layout/Breadcrumb';

// ===== 関連サイト ハブ 全面刷新（新デザイン憲章適用） =====
// 旧 _shared（角丸/影/#d4af37）を廃し、home/about の紺#1a2942・真鍮金#a38e65・BTN-08・細罫へ統一。
// 実文は working tree 現行実文を保持。外部公式URL（thebutler.jp / butlerbell.jp / butler-academy.jp）は変更禁止。
// 当ルートは Layout の pagesWithOwnFaq 登録済み＝FAQは本ページが自前描画する。

const cards = [
  {
    name: '全日本執事協会 THE BUTLER',
    role: '執事派遣サービス',
    en: 'Butler Service',
    desc: '当協会が運営する執事によるおもてなしのサービス。ご家庭からビジネス、VVIP対応まで、暮らしとおもてなしを包括的に支える窓口です。',
    img: '/images/generated/jba-fs-194-related-v8.jpg',
    imgAlt: '高級レジデンスで給仕する執事の様子',
    internal: '/related/the-butler',
    external: 'https://thebutler.jp/',
  },
  {
    name: '執事ベル',
    role: '情報発信ブランド',
    en: 'Media Brand',
    desc: '当協会 三代目会長・石井裕一のオフィシャル情報発信ブランド。YouTube「執事ベル」等を通じて、本物の執事の姿とおもてなしの心を広く社会に伝えています。',
    img: '/images/generated/jba-fs-195-related.jpg',
    imgAlt: '応接室でおもてなしをする執事の様子',
    internal: '/related/butler-bell',
    external: 'https://butlerbell.jp/',
  },
  {
    name: '日本執事アカデミー',
    role: '教育・養成機関',
    en: 'Training Institution',
    desc: '当協会が運営する執事の教育・養成機関。体系立てたカリキュラムで執事を育成し、所定の課程を修了した方へ協会認定資格を授与しています。',
    img: '/images/generated/jba-fs-196-related-v8.jpg',
    imgAlt: '執事の所作を学ぶ養成の様子',
    internal: '/related/butler-academy',
    external: 'https://butler-academy.jp/',
  },
];

const faqs = [
  {
    q: '関連サイトとはどのようなものですか？',
    a: '一般社団法人全日本執事協会を中心に、執事文化を支える組織・ブランドをまとめたご案内です。執事派遣サービスのTHE BUTLER、情報発信ブランドの執事ベル、教育・養成機関の日本執事アカデミーの3つをご紹介しています。',
  },
  {
    q: '各サイトと全日本執事協会はどのような関係ですか？',
    a: 'THE BUTLER と日本執事アカデミーは当協会が運営する事業・機関です。執事ベルは当協会 三代目会長・石井裕一のオフィシャル情報発信ブランドで、YouTube等を通じて執事文化を社会に伝えています。いずれも執事の学び・発信・実務を支える関連サイトです。',
  },
  {
    q: '各サイトの公式ページはどこから見られますか？',
    a: '各カードの「詳しく見る」から当協会内の紹介ページへ、「公式サイト」から各サイトの公式ページ（別ウィンドウ）へアクセスできます。THE BUTLER は thebutler.jp、執事ベルは butlerbell.jp、日本執事アカデミーは butler-academy.jp です。',
  },
];

const breadcrumbs = [{ label: 'ホーム', href: '/' }, { label: '関連サイト' }];

const BTN08_ON_NAVY = "relative inline-flex items-center justify-center bg-[#a38e65] text-white font-semibold border border-[#1a2942] px-[42px] py-[16px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#1a2942] hover:text-[#f8f6f0] hover:border-[#a38e65] cursor-pointer whitespace-nowrap before:content-[''] before:absolute before:inset-1 before:border before:border-[#1a2942]/40 before:pointer-events-none before:transition-colors before:duration-300 hover:before:border-[#a38e65]/50";

function NavyBand({ no, ja, en }: { no: string; ja: string; en: string }) {
  return (
    <div className="bg-[#1a2942] border-y border-[#a38e65]/25">
      <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 py-5 sm:py-[26px] flex items-center gap-4 sm:gap-6">
        <img src="/images/brand/jba-logo.png" alt="" aria-hidden="true" className="h-8 w-8 sm:h-9 sm:w-9 object-contain shrink-0 opacity-90" />
        <span className="font-['Playfair_Display',serif] text-[#d7b779] text-xl sm:text-[26px] tracking-[0.1em] shrink-0 leading-none">{no}</span>
        <h2 className="jba-display font-medium text-[#f8f6f0] text-lg sm:text-2xl lg:text-[26px] tracking-[0.08em] leading-tight">{ja}</h2>
        <span className="hidden md:block ml-auto font-['Playfair_Display',serif] italic text-[#a38e65] text-base lg:text-[19px] tracking-[0.12em]">{en}</span>
      </div>
    </div>
  );
}

export default function RelatedHubPage() {
  return (
    <Layout>
      {/* ===== ヒーロー — 全幅ビルボード型 ===== */}
      <section className="relative bg-[#1a2942] overflow-hidden min-h-[480px] lg:min-h-[540px] flex items-center">
        <img
          src="/images/generated/jba-space-room-02.jpg"
          alt="シャンデリアのあるサロンの広間"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(16,20,26,0.92)_0%,rgba(16,20,26,0.7)_50%,rgba(16,20,26,0.4)_100%)]"></div>
        <div className="relative z-10 w-full max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 pt-32 pb-16 lg:pt-36 lg:pb-20">
          <div className="max-w-[680px]">
            <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.32em] text-xs sm:text-[13px] text-[#d7b779] mb-4">Related Organizations</span>
            <div className="w-12 h-px bg-[#a38e65] mb-6"></div>
            <h1 className="jba-display font-normal text-white text-[clamp(26px,3.2vw,42px)] leading-[1.42] tracking-[0.04em] mb-6">
              <span className="block">執事文化を支える、</span>
              <span className="block">協会グループのご案内</span>
            </h1>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-white/90 leading-[1.95]">
              一般社団法人全日本執事協会を中心に、執事文化を支える組織・ブランドが連携し、学びから発信、実務までを一つの流れとしてつないでいます。それぞれの役割と、当協会とのつながりをご紹介します。
            </p>
          </div>
        </div>
      </section>
      {/* パンくず: ビルボード直後に配置（Yuichi 2026-07-17 指摘②）。共通Breadcrumbのヘッダー逃げpaddingを子セレクタで通常paddingへ上書き */}
      <div className="bg-white [&>div]:!pt-6">
        <Breadcrumb items={breadcrumbs} />
      </div>

      {/* ===== I. 協会グループの全体像 — リード＋画像 ===== */}
      <NavyBand no="I" ja="協会グループの全体像" en="Our Network" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="order-2 lg:order-1 text-left">
              <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl lg:text-[30px] leading-[1.5] tracking-[0.02em] mb-5">
                学びから実務まで、<span className="text-[#a38e65]">一つの流れとして</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.95] mb-4">
                一般社団法人全日本執事協会の活動は、単独で成り立っているわけではありません。執事の育成・認定・法人研修を担う協会を中心に、執事文化を社会へ伝える発信ブランド、そして実際の執事サービスを担うブランドが連携し、学びから実務までを一つの流れとしてつないでいます。
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.95]">
                このページでは、当協会と関わりの深い執事関連サイト――THE BUTLER、執事ベル、日本執事アカデミー――について、それぞれの役割と当協会とのつながりをご紹介します。執事という仕事の全体像を知る手がかりとしてご覧ください。
              </p>
            </div>
            <div className="order-1 lg:order-2">
              <img src="/images/generated/jba-interior-wardrobe-02.jpg" alt="執事サロンの調度と食器棚" className="w-full h-[300px] sm:h-[400px] md:h-[460px] object-cover object-top border border-[#a38e65]/30" />
            </div>
          </div>
        </div>
      </section>

      {/* ===== II. 3つの執事関連サイト — 白カード（画像上／英字eyebrow／役割チップ／内部・外部導線）===== */}
      <NavyBand no="II" ja="3つの執事関連サイト" en="Related Sites" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
            {cards.map((card) => (
              <article key={card.internal} className="group flex flex-col bg-white border border-[#e2ddd2] hover:border-[#a38e65]/70 transition-colors duration-300">
                <div className="relative h-52 sm:h-56 overflow-hidden">
                  <img src={card.img} alt={card.imgAlt} className="absolute inset-0 w-full h-full object-cover object-top" />
                  <span className="absolute top-4 left-4 bg-[#1a2942]/90 text-[#d7b779] text-[11px] tracking-[0.08em] px-3 py-1 border border-[#a38e65]/40">{card.role}</span>
                </div>
                <div className="flex flex-col flex-1 p-7 sm:p-8 text-left">
                  <span className="block font-['Playfair_Display',serif] italic text-[#8f7a56] text-sm tracking-[0.06em] mb-2">{card.en}</span>
                  <h3 className="jba-display font-medium text-[#1a2942] text-xl sm:text-2xl leading-[1.4] mb-4">{card.name}</h3>
                  <p className="font-['Noto_Serif_JP',serif] text-sm sm:text-base text-[#4a4638] leading-[1.9] mb-6 flex-1">{card.desc}</p>
                  <div className="flex flex-col gap-3 pt-5 border-t border-[#e2ddd2]">
                    <Link to={card.internal} className="inline-flex items-center gap-2 font-['Noto_Serif_JP',serif] text-[15px] text-[#1a2942] tracking-[0.04em] border-b border-[#a38e65] pb-1 self-start hover:text-[#8f7a56] transition-colors duration-300">
                      詳しく見る <span className="text-[#a38e65] group-hover:translate-x-1 transition-transform">→</span>
                    </Link>
                    <a href={card.external} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-['Noto_Serif_JP',serif] text-sm text-[#8f7a56] hover:text-[#a38e65] transition-colors self-start">
                      公式サイト <i className="ri-external-link-line text-xs"></i>
                    </a>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ===== III. 協会と関連サイトのつながり — 紺パネル＋画像2カラム ===== */}
      <NavyBand no="III" ja="協会と関連サイトのつながり" en="Relationship" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 items-stretch border border-[#e2ddd2] overflow-hidden">
            <div className="relative min-h-[300px] lg:min-h-[420px] bg-black order-1">
              <img src="/images/generated/jba-fs-197-related-v8.jpg" alt="協会を母体に学び・発信・実務がつながる執事のネットワーク" className="absolute inset-0 w-full h-full object-cover object-top" />
            </div>
            <div className="order-2 bg-[#1a2942] flex flex-col justify-center px-8 sm:px-12 lg:px-14 py-12 lg:py-16 text-left">
              <span className="block font-['Playfair_Display',serif] italic text-[#a38e65] text-sm tracking-[0.06em] mb-4">How We Are Connected</span>
              <h3 className="jba-display font-medium text-[#f8f6f0] text-2xl sm:text-3xl leading-[1.5] tracking-[0.02em] mb-6">
                一つの協会のもとで、<span className="text-[#d7b779]">つながっています</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.95] mb-4">
                一般社団法人全日本執事協会が運営母体となり、その執事サービスがTHE BUTLER、教育・養成機関が日本執事アカデミーです。協会 三代目会長・石井裕一のオフィシャル情報発信ブランドが執事ベル――学びと発信と実務が、一つの協会のもとでつながっています。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== IV. よくあるご質問 — 罫線リスト（自前描画）===== */}
      <NavyBand no="IV" ja="よくあるご質問" en="FAQ" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="max-w-4xl mx-auto border-t border-[#e2ddd2]">
            {faqs.map((f) => (
              <div key={f.q} className="border-b border-[#e2ddd2] py-6">
                <h3 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl leading-[1.5] mb-3 flex items-start gap-3">
                  <span className="font-['Playfair_Display',serif] text-[#a38e65] text-xl leading-none pt-0.5">Q.</span><span>{f.q}</span>
                </h3>
                <p className="font-['Noto_Serif_JP',serif] text-sm sm:text-base text-[#4a4638] leading-[1.95] pl-8">{f.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== 締めCTAパネル ===== */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="bg-[#1a2942] border border-[#a38e65]/45 p-8 sm:p-10 md:p-14 text-center">
            <h3 className="jba-display font-medium text-2xl sm:text-3xl text-[#f8f6f0] tracking-[0.04em]">執事の学びや資格に関心をお持ちの方へ</h3>
            <div className="w-11 h-px bg-[#a38e65] mx-auto mt-4 mb-6"></div>
            <p className="text-base sm:text-lg text-[#e7e2d8] mb-8 font-['Noto_Serif_JP',serif] max-w-2xl mx-auto leading-[1.9]">執事資格制度や法人研修、各サービスについて、ご不明な点はお気軽にお問い合わせください。</p>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center">
              <Link to="/qualifications" className={BTN08_ON_NAVY}>執事資格制度を見る</Link>
              <Link to="/contact" className={BTN08_ON_NAVY}>お問い合わせ</Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
